export enum ScanModes {
  Automatic = 1,
  Custom = 2,
}
